import { Component, OnInit, ViewChild } from '@angular/core';
import {FormControl, FormGroup, Validators, FormBuilder} from '@angular/forms';
import { GlobalService } from 'src/app/global.service';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import { LoginService } from 'src/app/Common/Services/login.service';
import { AdminService } from 'src/app/Common/Services/admin.service';
import { ToastrService } from 'ngx-toastr';
import { HttpHeaders } from '@angular/common/http';
import { MatSort } from '@angular/material/sort';

export interface PeriodicElement {
  promotion: string;
 // storagepath: string;
  agentname: string;
  type: string;
}

export interface filetype {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-promotion-ads',
  templateUrl: './promotion-ads.component.html',
  styleUrls: ['./promotion-ads.component.css']
})

export class PromotionAdsComponent implements OnInit {

  minDate =new Date();
  date =new Date();

  filetypes:filetype[]= [
    {value:'Promotions', viewValue:'Promotions'},
    {value:'Advertisements', viewValue:'Advertisements'}
  ];
  uploadForm: FormGroup;
  agentLists: any[] = [];
  fileToUpload: File = null;

  public agentCtrl: FormControl = new FormControl();

  constructor(public global: GlobalService,private _formbuilder: FormBuilder,public loginservice:LoginService,public adminservice:AdminService,private toastr: ToastrService){

    this.uploadForm=this._formbuilder.group({
      type: ['',[Validators.required]],
      agentNameList: ['',[Validators.required]],
      promotion: ['',[Validators.required]],
      fromdate :[this.minDate,[Validators.required]],
      todate:['',[Validators.required]]
    });
  }

  displayedColumns: string[] = ['promotion', 'agentname', 'type', 'action'];
  dataSource ;
  promotionList :PeriodicElement[] =[];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  ngOnInit() {
    this.getAllLOvs("promotion-ads");
    this.getpromotionListing();
    
    if (this.promotionList.length != 0) {
      this.dataSource = new MatTableDataSource(this.promotionList);
      this.dataSource.paginator = this.paginator;
    }
  }

  getAllLOvs(value:string){
    this.loginservice.getPageLOVs(value).subscribe((res:any)=>{
      if(res.responseBody != undefined){
        console.log("LOVs",res.responseBody);
        this.agentLists = res.responseBody.agentNameList;
      }
    })
  }

  submit(){
    
    var type=this.uploadForm.get('type').value;
    var agentname =this.uploadForm.get('agentNameList').value;  
    var s =this.uploadForm.get('promotion').value.split('%');
    let promotion ="";
    if((s == "" || null) || (type == "" || null )|| (agentname == "" || null )){
      this.toastr.error("Kindly Enter All Values", undefined, {
        positionClass: 'toast-bottom-right',
        timeOut: 1000
      });
    }
    else{
    if(s[1] == undefined){
       promotion=s[0];
    }
    else 
    {
       promotion=s[0]+"&"+s[1];
    }
    var fromdate = this.uploadForm.get('fromdate').value;
    var todate = this.uploadForm.get('todate').value;
    let Form = JSON.stringify(this.uploadForm.value);
    this.adminservice.promotionupload(type,promotion,agentname,Form).subscribe((res:any)=>{
    
    console.log(res);
    if(res.responseBody.ValidateMsg){
      this.toastr.success(res.responseBody.ValidateMsg, undefined, {
        positionClass: 'toast-bottom-right',
        timeOut: 6000
      });
      this.uploadForm.reset();
      this.getpromotionListing();
    }
    })
}
}

getpromotionListing(){
  
  this.loginservice.getpromotionListing().subscribe((res:any) => {
    if(res.responseBody != undefined){
      
      console.log("Promotion Listing :", res.responseBody);
      this.promotionList = res.responseBody.list;
      console.log("Listing:", this.promotionList)
      this.dataSource = new MatTableDataSource(this.promotionList);
      this.dataSource.paginator = this.paginator;
    }
  })
}


delete(element){
  
  var sno =element.sno;
  var deleteflag ="PA"; 
 this.adminservice.deletFile(sno,deleteflag).subscribe((res:any) => {

if(res.responseBody.validationMsg){
  this.toastr.success(res.responseBody.validationMsg, undefined, {
    positionClass: 'toast-bottom-right',
    timeOut: 6000
  });
}
this.getpromotionListing();
 })
}

}



